import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { 
	DocumentType as objectPayload, 
	DocumentTypeAddPayload as objectAddPayload, 
	DocumentTypeEditPayload as objectEditPayload, 
	DocumentTypeForm as objectForm
} from './document-type.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class DocumentTypeService {

	private serviceName = 'DocumentTypeService';

	private token!: string;
	private basePath = environment.interop.basePath;

	public getListDTUrl =
		this.basePath +
		environment.interop.urbanism.nomenclatoare.documentType.listDT

	private getListUrl =
		this.basePath +
		environment.interop.urbanism.nomenclatoare.documentType.list

	private oneUrl =
		this.basePath +
		environment.interop.urbanism.nomenclatoare.documentType.one

	private updateUrl =
		this.basePath +
		environment.interop.urbanism.nomenclatoare.documentType.update

	private storeUrl =
		this.basePath +
		environment.interop.urbanism.nomenclatoare.documentType.store

	private deleteUrl =
		this.basePath +
		environment.interop.urbanism.nomenclatoare.documentType.delete

	private clearCacheUrl = this.basePath + environment.interop.urbanism.nomenclatoare.documentType.clearCache;

	private httpOptions: any;

	constructor(private http: HttpClient) { }

	setToken(token: string) {
		this.token = token;
		this.httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Accept: 'application/json',
				Authorization: `Bearer ${this.token}`,
			}),
		};
	}

	clearCache() {
		return this.http.get(this.clearCacheUrl, this.httpOptions);
	}

	update(data: objectEditPayload) {
		return this.http.put(
			this.updateUrl,
			data,
			this.httpOptions
		);
	}

	store(data: objectAddPayload) {
		return this.http.post(
			this.storeUrl,
			data,
			this.httpOptions
		);
	}

	delete(id: number) {
		return this.http.delete(this.deleteUrl + id);
	}

	one(id: number) {
		return this.http.get(this.oneUrl + id, this.httpOptions);
	}

	getRecordsList() {
		return this.http
			.get<{ errors: boolean; data: any[]; status_code: number }>(
				this.getListUrl
			)
			.pipe(
				map((response) =>
					response.data.map((item) => ({
						id: item.id,
						name: item.name,
					}))
				),
				catchError((error) => {
					console.error('Error in get request with service ' + this.serviceName, error);
					return throwError(error);
				})
			);
	}

}
